module.exports = __webpack_public_path__ + "static/img/casePhoto.dd31841.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/casePhoto.jpeg
// module id = 3W2d
// module chunks = 1